// extracted by mini-css-extract-plugin
module.exports = {"containerBaseSlideer":"HomeContentBaseSlider_containerBaseSlideer__QxT9m"};